<template>
    <div>
      <div v-if="params.value !== 'header'" class="box" style="max-width: 400px; min-width: 300px">
        <div class="title is-size-5">
          <div v-if="process" class="is-flex" style="justify-content: space-between; align-items: center;">
            <p>Último Diagnóstico</p>
            <i v-if="icon" class="material-icons is-size-6 has-text-dark circle mr-5">{{ icon }}</i>
          </div>
          <div v-if="!process" class="is-flex" style="justify-content: space-between; align-items: center;">
            <p>Crear Diagnóstico</p>
            <i v-if="icon" class="material-icons is-size-6 has-text-dark circle mr-5">{{ icon }}</i>
          </div>
        </div>
        <div class="body">
          <div v-if="process">
            <span><strong class="is-capitalized">{{ process.nombre }}</strong> es el último diagnóstico creado el {{ dateToString(process.created) }}.</span>
          </div>
          <div v-if="!process">
            <p>
              Actualmente esta empresa no tiene diagnóstico en {{ params.colDef.headerName }}.
              <br><br>
              <strong class="is-size-7">Clic en la celda para crear uno nuevo.</strong>
            </p>
          </div>
        </div>
      </div>
      <div v-if="params.value === 'header'" class="ag-tooltip-standar"> 
        {{ params.colDef.headerName }}
      </div> 
    </div>
</template>
<script>
export default {
    data(){
        return {
            params: this.$parent.params,
            process: null,
            icons: {
              "climaOld" : 'list',
              "leader" : 'stars',
              "clima" : 'ac_unit',
              "frpNew" : 'blur_on',
              "frp" : 'list',
              "cultura" : 'stream',
            },
            icon: null
        }
    },
    beforeMount() {
      if (this.params.value !== 'header' && this.params.data[`${this.params.colDef.field}ProcessLast`]){
        this.process = this.params.data[`${this.params.colDef.field}ProcessLast`]
      }
      // Set Icon
      this.icon = this.icons[this.params.colDef.field]
    },
    methods:{
      dateToString(d){
        let date = new Date(d);
        let options = {year: 'numeric', month: 'long', day: 'numeric'};
        date = date.toLocaleDateString(undefined, options);
        return date;
      },
    }
}
</script>
<style lang="scss" scoped>
.title {
    padding: 10px;
    border-radius: 10px;
    background-color: #F3F3F3;
}

.circle {
  padding: 10px;
  border-radius: 50%;
  background-color: #e8d3f7;
}

.ag-tooltip-standar {
    background-color: #fff;
    color: rgba(0,0,0, 0.87);
    padding: 8px;
    border: none #e2e2e2;
    border-radius: 2px;
    transition: opacity 1s;
    white-space: normal;
    box-shadow: 5px 5px 10px rgba(0,0,0, 0.3)
}
</style>


// WEBPACK FOOTER //
// src/components/empresas/components/TooltipDiagnosis.vue